import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import React, { Suspense } from "react";
import UserRoutes from "./UserRoutes.jsx";
import AdminRoutes from "./AdminRoutes.jsx";
import SharedRoutes from "./SharedRoutes.jsx";

const Landing = React.lazy(() => import("./pages/guest/landing/Landing.jsx"));
const Login = React.lazy(() => import("./pages/guest/Login.jsx"));
const Logout = React.lazy(() => import("./pages/guest/Logout.jsx"));
const ForgotPassword = React.lazy(
  () => import("./pages/guest/ForgotPassword.jsx"),
);
const ResetPassword = React.lazy(
  () => import("./pages/guest/ResetPassword.jsx"),
);
const CreateAccount = React.lazy(
  () => import("./pages/guest/CreateAccount.jsx"),
);
import TemplateGuest from "./pages/guest/TemplateGuest.jsx";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { SidebarProvider } from "./context/SidebarContext.jsx";
import ReloadOnStaleChunk from "./routes/ReloadOnStaleChunk.jsx";

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  return (
    <ReloadOnStaleChunk>
      <Suspense
        fallback={
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        }
      >
        <SidebarProvider>
          <Routes>
            <Route path="/" element={<TemplateGuest content={<Landing />} />} />
            <Route
              path="/login"
              element={<TemplateGuest content={<Login />} />}
            />
            <Route
              path="/forgot-password"
              element={<TemplateGuest content={<ForgotPassword />} />}
            />
            <Route
              path="/reset-password"
              element={<TemplateGuest content={<ResetPassword />} />}
            />
            <Route
              path="/create"
              element={<TemplateGuest content={<CreateAccount />} />}
            />
            <Route path="/logout" element={<Logout />} />
            {UserRoutes}
            {SharedRoutes}
            {AdminRoutes}
          </Routes>
        </SidebarProvider>
      </Suspense>
    </ReloadOnStaleChunk>
  );
}

export default App;
